export default __webpack_public_path__ + "static/media/u.6ac54e05.jpg";